import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EventService {
    private readonly LOCAL_STORAGE_KEY = 'IsAccept';
    private isAcceptSubject: BehaviorSubject<boolean>;
    public isAccept$;

    constructor() {
        const savedIsAccept = localStorage.getItem(this.LOCAL_STORAGE_KEY);
        const initialAccept = savedIsAccept === 'true';
        this.isAcceptSubject = new BehaviorSubject<boolean>(initialAccept);
        this.isAccept$ = this.isAcceptSubject.asObservable();
    }

    setIsAccept(value: boolean) {
        localStorage.setItem(this.LOCAL_STORAGE_KEY, value.toString());
        this.isAcceptSubject.next(value);
    }

    getIsAccept(): boolean {
        return this.isAcceptSubject.value;
    }
}
